import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Button } from "@/libraries/design/components/button/src/button";
import { wacToken } from "@/libraries/design/foundations";

import { Picture } from "../../components/wpl/image/src/image";

const stickyWrapperStyle = css({
    lineHeight: 1,
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    order: -1
});
const imktNavbarStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    display: "block",
    order: -1,
    width: "100%"
});
const containerFluidStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    backgroundColor: wacToken("color.neutral.light0"),
    boxShadow: token("elevation.shadow.overlay"),
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both",
    position: "relative",
    maxHeight: "140px",
    overflow: "hidden",
    zIndex: 9,
    minHeight: "72px"
});
const rowStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    marginInlineStart: "auto",
    marginInlineEnd: "auto",
    maxWidth: "1200px"
});
const columnStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    float: "left",
    minHeight: "1px",
    paddingInlineStart: "16px",
    paddingInlineEnd: "16px",
    position: "relative",
    width: "100%",
    display: "flex",
    flexFlow: "row wrap",
    alignItems: "center",
    justifyContent: "space-between"
});
const titleWrapperStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
const rightNavStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    paddingBlockEnd: "15px",
    paddingBlockStart: "15px"
});
const linkStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    verticalAlign: "baseline",
    color: wacToken("color.primary.blue"),
    display: "block",
    transformStyle: "preserve-3d",
    height: "60px",
    textDecoration: "none"
});
const logoStyle = css({
    lineHeight: 1,
    boxSizing: "inherit",
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    color: wacToken("color.primary.blue"),
    height: "30px",
    maxWidth: "100%",
    marginBlockEnd: "16px",
    verticalAlign: "bottom",
    position: "relative",
    insetBlockStart: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none"
});

export const SourcetreeAppNav = () => {
    return (
        <div css={stickyWrapperStyle}>
            <nav css={imktNavbarStyle}>
                <div css={containerFluidStyle}>
                    <div css={rowStyle}>
                        <div css={columnStyle}>
                            <div css={titleWrapperStyle}>
                                <a href="/" css={linkStyle}>
                                    <Picture
                                        image={{
                                            src: "https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108",
                                            alt: "Sourcetree logo"
                                        }}
                                        style={{
                                            height: "30px"
                                        }}
                                        css={logoStyle}
                                    />
                                </a>
                            </div>
                            <div css={rightNavStyle}>
                                <Button
                                    variant="primary"
                                    color="blue"
                                    href="https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.14_297.zip"
                                    dataEventProps={{
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "navbar",
                                        "data-product-key": "sourcetreeapp",
                                        "data-label-english": "Download free"
                                    }}
                                >
                                    {" "}
                                    Download free
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};
